import { breakpoints, css } from '../../../styles/theme';
import { rem } from 'polished';

export const StylesAP = css`
    max-height: fit-content;
    border: none;
    padding: ${rem(10)} ${rem(15)};
    font-size: ${({ theme }) => theme.fontSizes.textBase};
    border-bottom: 2px solid ${({ theme }) => theme.colors.primary};

    @media (max-width: ${breakpoints.md}px) {
        &.expanded-grid {
            border-bottom: 5px solid ${({ theme }) => theme.colors.primary};
            margin-bottom: ${rem(58)};
        }
    }

    &.collapsed-grid {
        max-height: ${rem(75)};
    }

    &.collapsed-grid {
        max-height: ${rem(75)};
    }

    grid-template-areas:
        'toggle-filters toggle-filters toggle-filters toggle-filters'
        'budgetTitle . . .'
        'priceRange priceRange priceRange priceRange'
        'fuelTitle . . .'
        'fuelFilter fuelFilter fuelFilter fuelFilter'
        'gearboxTitle . . .'
        'gearboxFilter gearboxFilter gearboxFilter gearboxFilter'
        'legalText legalText legalText legalText'
        '. . . resetFilter'
        'closeButton closeButton closeButton closeButton';

    row-gap: ${rem(20)};

    &.SOL-filter.mobile-filter {
        grid-template-areas:
            'toggle-filters toggle-filters toggle-filters toggle-filters'
            'budgetTitle . . .'
            'priceRange priceRange priceRange priceRange'
            'fuelTitle . . .'
            'fuelFilter fuelFilter fuelFilter fuelFilter'
            'gearboxTitle . . .'
            'gearboxFilter gearboxFilter gearboxFilter gearboxFilter'
            '. . . resetFilter'
            'closeButton closeButton closeButton closeButton';
    }

    .filter-grid__prices {
        grid-area: priceRange;

        @media (min-width: ${breakpoints.md}px) {
            margin-right: ${rem(25)};
            max-width: ${rem(280)};
        }
    }

    .filterbox-body h3 {
        color: ${({ theme }) => theme.colors.grey1};
    }

    .slider-over {
        @media (max-width: ${breakpoints.md}px) {
            margin-left: 0;
        }
    }

    .header {
        top: ${rem(22)};
    }

    .grid-button {
        min-width: ${rem(120)};
        padding: 0 ${rem(15)};
        text-align: left;

        &:hover {
            color: ${({ theme }) => theme.colors.white};
        }
    }

    .budget-title,
    .fuel-title,
    .gearbox-title {
        font-size: ${({ theme }) => theme.fontSizes.textBase};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        padding-top: ${rem(10)};
    }

    .toggle-filters {
        grid-area: toggle-filters;
    }

    .toggleOption {
        font-size: ${({ theme }) => theme.fontSizes.textSmall};
    }

    .frontpage-legaltext {
        font-size: ${({ theme }) => theme.fontSizes.textTiny};
        padding-top: ${rem(15)};
        line-height: ${rem(14)};
    }

    .mobile-filter-close-button {
        background-color: ${({ theme }) => theme.colors.grey13};
        color: ${({ theme }) => theme.colors.white};

        span {
            left: ${rem(-8)};
        }
    }
`;
